const BASE_URL = 'ai-service/api/ai-report-publish-templates'

const aiReportPublishTemplatesRequests = {
  getPublishTemplatesRequest: ({ aiObjectId }) => ({
    url: `${BASE_URL}/ai-object/${aiObjectId}`,
    method: 'get',
  }),
  createPublishTemplateRequest: ({ template }) => ({
    url: BASE_URL,
    method: 'post',
    data: template,
  }),
  updatePublishTemplateRequest: ({ template }) => ({
    url: `${BASE_URL}/${template.id}`,
    method: 'put',
    data: { name: template.name, columns: template.columns },
  }),
  deletePublishTemplateRequest: ({ id }) => ({
    url: `${BASE_URL}/${id}`,
    method: 'delete',
  }),
}

export default aiReportPublishTemplatesRequests
